import {
	routeEdgerRoll,
	routeUniversalRoll,
} from "@/setup/routes/catalog.routes";
import { Roll } from "@/shared/models/Roll";
import { MenuOptionType } from "@dexteel/mesf-core";
import { Edit, RemoveRedEyeOutlined } from "@mui/icons-material";

type Props = {
	onEdit: (roll: Roll) => void;
};
export const useBrokenRollsOptionsFunctions = ({ onEdit }: Props) => {
	const getMenuOptions = (data: Roll) => {
		let options: MenuOptionType[] = [];
		if (data) {
			options = options.concat([
				{
					name: "See in Catalogs",
					key: "see_in_catalogs",
					onClick: () => {
						const url =
							data.RollTypeCode == "E" ? routeEdgerRoll : routeUniversalRoll;
						window.open(`${url}/${data.PartId}`, "_blank");
					},
					icon: <RemoveRedEyeOutlined />,
				},
				{
					name: "Edit Roll",
					key: "edit_roll",
					onClick: () => onEdit(data),
					icon: <Edit />,
				},
			]);
		}
		return options;
	};

	return {
		getMenuOptions,
	};
};
